// Chrome offers to save any type="password"; CSS masking keeps the field out of that heuristic
const CSS_MASK = { WebkitTextSecurity: 'disc', textSecurity: 'disc' };

// Feature-detected once: without support the field must stay a real password
const supportsTextSecurity = (() => {
  if (typeof document === 'undefined') return false;
  const probe = document.createElement('input');
  return (
    'webkitTextSecurity' in probe.style || 'textSecurity' in probe.style
  );
})();

const plain = (inputProps) => ({
  type: 'text',
  autoComplete: 'off',
  inputProps: {
    ...inputProps,
    autoCorrect: 'off',
    autoCapitalize: 'off',
    spellCheck: false,
  },
});

// Spread onto a MUI TextField; `visible` is for fields with a show/hide toggle
export const maskedFieldProps = (inputProps = {}, visible = false) => {
  if (visible) return plain(inputProps);

  // Without text-security support the field stays a real password: a dialog is
  if (!supportsTextSecurity) {
    return { type: 'password', autoComplete: 'off', inputProps };
  }

  const base = plain(inputProps);
  return {
    ...base,
    inputProps: {
      ...base.inputProps,
      // Inline, so masking cannot be lost if a stylesheet fails to load
      style: { ...CSS_MASK, ...(inputProps.style || {}) },
    },
  };
};

export default maskedFieldProps;
